import { createContext } from "react";

export const NavbarContext = createContext()
export const ColorModeContext = createContext({ toggleColorMode: () => {} });